import { AnyAction } from 'redux'
import { Action } from 'redux-actions'
import * as actions from './actions'

export const hidden =
  (bannerId?: string) =>
  (action: AnyAction): action is Action<string> =>
    [actions.BANNER_HIDE].includes(action.type) && (action as Action<string>).payload === bannerId
